import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import getStyles from './getStyles';
import ProductListItem from '../products/ProductListItem';

function SimilarProducts(props) {
  const styles = getStyles(props);
  const { similarProducts } = props;

  return (
    <UX2.Element.Block>
      <UX2.Element.Text.Major
        data-aid={ dataAids.SIMILAR_PRODUCT_RENDERED }
        children={ props.translate('products.similarProductsTitle') }
        style={ styles.similarProducts }
      />
      <UX2.Component.Grid data-aid={ dataAids.PRODUCT_LIST_RENDERED } xs={ 2 } md={ 4 }>
        { similarProducts.slice(0, 4).map(product => { // TODO: change this for carrousel component.
          return (
            <UX2.Component.Grid.Cell key={ product.slug } style={{ marginBottom: 'large' }}>
              <ProductListItem product={ product }
                productsPerRow={ 4 }
                renderMode={ props.renderMode }
                galleryShowBorder={ props.galleryShowBorder }
                imageCropMethod={ props.imageCropMethod }
                imageShape={ props.galleryImageShape }
                isRibbonShown={ false }
                isRatingShown={ false }
              />
            </UX2.Component.Grid.Cell>
          );
        })}
      </UX2.Component.Grid>
    </UX2.Element.Block>
  );
}

/**
 * #Temporary in BEAR-914
 * After BEAR-1005 is done the following propTypes should be deleted
 * galleryShowBorder,
 * imageCropMethod,
 * galleryImageShape
*/

SimilarProducts.propTypes = {
  renderMode: PropTypes.string,
  translate: PropTypes.func,
  similarProducts: PropTypes.array,
  galleryShowBorder: PropTypes.bool,
  imageCropMethod: PropTypes.string,
  galleryImageShape: PropTypes.string
};

export default SimilarProducts;
